angular
    .module('empower.uploadDocument')
    .constant('documentSelectionsConst', {
        TRAVEL_TYPES: [
            { id: 1, text: 'Personal car' },
            { id: 2, text: 'Taxi / Uber' },
            { id: 3, text: 'Public Transport' }
        ]
    });